export var CookState;
(function (CookState) {
    CookState[CookState["Raw"] = 0] = "Raw";
    CookState[CookState["Cooked"] = 1] = "Cooked";
    CookState[CookState["Burnt"] = 2] = "Burnt";
})(CookState || (CookState = {}));
;
/**
 * Component which represents a cookable food item.
 */
export function Cookable(base) {
    return class extends base {
        constructor() {
            super(...arguments);
            this.cookedTime = 0;
            this.cookState = CookState.Raw;
            this.cookTime = 1;
            this.burnTime = 1;
        }
        getProperties() {
            return {
                'state': this.cookState == CookState.Raw ? 'raw' : this.cookState == CookState.Cooked ? 'cooked' : 'burnt',
            };
        }
        isCooked() {
            return this.cookState == CookState.Cooked;
        }
        onCooked() { }
        onBurnt() { }
        cook() {
            this.cookedTime++;
            switch (this.cookState) {
                case CookState.Raw:
                    if (this.cookedTime >= this.cookTime) {
                        this.cookState = CookState.Cooked;
                        this.cookedTime = 0;
                        this.onCooked();
                    }
                    break;
                case CookState.Cooked:
                    if (this.cookedTime >= this.burnTime) {
                        this.cookState = CookState.Burnt;
                        this.cookedTime = 0;
                        this.onBurnt();
                    }
                    break;
            }
        }
    };
}
export function isCookable(obj) {
    return 'cook' in obj;
}
